export class RatesPageUtil {
  static prepareAirportSuggestion(airportList, isRatesFilter?: boolean) {
    return airportList?.map((item) => {
      const keywords = [
        item?.airportCode,
        item?.city?.cityCode,
        ...item?.airportName?.split(' '),
        ...item?.city?.cityName?.split(' '),
      ].filter((keyword) => keyword.length > 2);

      return {
        label: isRatesFilter
          ? `${item.airportName} (${item?.airportCode})`?.trim()
          : `${item?.airportCode} - ${item?.city?.cityName} ${item.airportName}`?.trim(),
        iconUrl: '/assets/media/icons/default/icon-airplane.svg',
        value: item?.airportCode,
        group: isRatesFilter
          ? `${[item?.city?.cityName]
              .filter((str) => str?.length > 0)
              .join(' - ')} (All Airports)`
          : `${[item?.city?.cityCode, item?.city?.cityName]
              .filter((str) => str?.length > 0)
              .join(' - ')} (All Airports)`,
        groupIconUrl: '/assets/media/icons/default/icon-building.svg',
        keywords,
        object: item,
      };
    });
  }

  static groupFilteredOptions(options): any[] {
    const groupedFilteredOptions = [];

    options?.forEach((item) => {
      const groupName = item.group ?? '',
        groupWithSameName = groupedFilteredOptions.find(
          (group) => group.name === groupName,
        );
      if (groupWithSameName === undefined) {
        const newGroup = {
          name: groupName,
          options: [item],
        };
        groupedFilteredOptions.push(newGroup);
      } else {
        groupWithSameName.options.push(item);
      }
    });
    groupedFilteredOptions?.forEach((groupedOption) => {
      if (groupedOption?.options?.every((option) => option?.selected)) {
        groupedOption.selected = true;
      }
    });
    return groupedFilteredOptions;
  }
}
